/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateBoostDto { 
    name: string;
    /**
     * Awarded-balance multipliers (\'*\' = campaign-wide). Record<EngagementFlowType | \'MANUAL\' | \'*\', number>; values > 0.1. At least one of pointsMultipliers/tierMultipliers must be non-empty.
     */
    pointsMultipliers?: object;
    /**
     * Tier-point multipliers (\'*\' = campaign-wide). Record<EngagementFlowType | \'MANUAL\' | \'*\', number>; values > 0.1. Per-channel keys require points-based tiers.
     */
    tierMultipliers?: object;
    /**
     * Shopify sale-origin filter for purchase/manual boosts (omit = ALL). Independent of the multiplier channel keys.
     */
    saleChannel?: CreateBoostDto.SaleChannelEnum | null;
    /**
     * POS location subfilter (Shopify location ids; numeric or gid). Only valid when saleChannel is ALL or POS; rejected for ONLINE_STORE.
     */
    saleChannelLocationIds?: Array<string> | null;
    /**
     * Window start as a wall-clock time evaluated in `timezone` — send the local clock time with a Z suffix (e.g. 2026-06-19T15:34:00Z means 15:34 in `timezone`). NULL = no start bound.
     */
    startsAt?: string | null;
    /**
     * Window end (exclusive) as a wall-clock time evaluated in `timezone` — send the local clock time with a Z suffix (e.g. 2026-06-19T18:00:00Z means 18:00 in `timezone`). NULL = no end bound.
     */
    endsAt?: string | null;
    /**
     * 0=Sun..6=Sat; NULL = every day
     */
    daysOfWeek?: Array<number> | null;
    /**
     * Hour-of-day window start 0..23 (NULL = all day)
     */
    hourStart?: number | null;
    /**
     * Hour-of-day window end 1..24, exclusive (NULL = all day)
     */
    hourEnd?: number | null;
    /**
     * IANA timezone every schedule field (window bounds + day/hour constraints) is evaluated in, e.g. Europe/Madrid
     */
    timezone: string;
    active?: boolean;
}
export namespace CreateBoostDto {
    export const SaleChannelEnum = {
        All: 'ALL',
        OnlineStore: 'ONLINE_STORE',
        Pos: 'POS'
    } as const;
    export type SaleChannelEnum = typeof SaleChannelEnum[keyof typeof SaleChannelEnum];
}


